/*
 * Copyright (c) 2026-present Amida Technology Solutions, Inc.
 * All rights reserved.
 *
 * Licensed under the Amida proprietary license.
 * See LICENSE file in the project root for license information.
 */

/**
 * What each role is called on screen. The server's keys are lower-case
 * identifiers; people read "HR" and "IT", not "Hr" and "It".
 */
const ROLE_NAMES: Record<string, string> = {
  admin: 'Admin',
  contracts: 'Contracts',
  hr: 'HR',
  it: 'IT',
  leadership: 'Leadership',
  operations: 'Operations',
};

/** A role's name, or the key with a capital where a new role has no name yet. */
export function roleName(key: string): string {
  return ROLE_NAMES[key] ?? key.charAt(0).toUpperCase() + key.slice(1);
}
